const component = "section-details-drawer";

export const sectionDetailsDrawer = {
  component,
  sectionName: `${component}/section-name`,
  editButton: `${component}/edit-button`,
  deleteSectionButton: `${component}/delete-section-button`,
  cannotDeleteSectionText: `${component}/cannot-delete-section-text`,
  saveButton: `${component}/save-button`,
  closeButton: `${component}/close-button`,
  editForm: {
    sectionNameInput: `${component}/edit-form/name-input`,
    sectionAreaInput: `${component}/edit-form/area-input`,
    sectionParentName: `${component}/edit-form/parent-name`,
  },
};
